import { useState } from 'react'
import { useQueryClient } from 'react-query'

import { useCurrentUser } from 'hooks/useCurrentUser'
import { useMutation } from 'hooks/useMutation'
import { useQuery } from 'hooks/useQuery'

import { createPostRoom, fetchRoom } from 'utils/queries'
import { Toast } from 'utils/toast'

import { Room } from 'types/chat'

export const usePostRoom = ({ postId }: { postId?: string }) => {
  const queryClient = useQueryClient()
  const { data: currentUser } = useCurrentUser()

  const queryKey = ['postRoom', postId]
  const [roomId, setRoomId] = useState<string | undefined>(
    queryClient.getQueryData<Room>(queryKey)?.id || undefined,
  )

  const roomQuery = useQuery<Room | null>(
    queryKey,
    () => (roomId ? fetchRoom({ roomId }) : Promise.resolve(null)),
    {
      enabled: !!roomId,
    },
  )

  const createRoom = useMutation<{ id: string }>(
    () =>
      postId && currentUser ? createPostRoom({ postId, user: currentUser }) : Promise.reject(),
    {
      onSuccess: (data) => {
        setRoomId(data.id)
      },
      onError: () => {
        Toast.error('Unable to create post chat room', 'Please try again')
      },
    },
  )

  return {
    ...roomQuery,

    // Mutations
    createRoom,
  }
}
